export default "__VITE_PUBLIC_ASSET__58ba58ce__"